module.exports = __webpack_public_path__ + "static/media/clipping_mask.fragment.0ef20f4f.glsl";